<template>

  <v-container fluid class="px-0 route-info-driving-directions">

    <!-- Route Map -->
    <route-map class="py-2" :route="route" v-if="showMap" />
    <div class="view-map-action-container" v-else>
      <v-btn color="gray" @click="showMap = !showMap">
        View Map
      </v-btn>
    </div>

    <!-- Route Driving Directions -->
    <route-driving-directions class="mt-8 mb-4" :route="route" />

  </v-container>

</template>

<script>
import RouteMap from '@/components/routes/RouteMap'
import RouteDrivingDirections from '@/components/routes/RouteDrivingDirections'

export default {
  name: 'RouteInfoDrivingDirections',

  components: {
    RouteMap,
    RouteDrivingDirections
  },

  props: {
    routeId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      showMap: false
    }
  },

  computed: {
    route () {
      return this.$parent.route
    }
  }
}
</script>

<style scoped>
  .route-info-driving-directions .view-map-action-container {
    border: 1px solid #525252;
    border-radius: 4px;
    padding-top: 110px;
    height: 230px;
    text-align: center;
  }
</style>
